module.exports = __webpack_public_path__ + "media/images/cms/img_slide_04-35c1d1b2b9fc71274f27b389c5c9196d.jpg";